<div class="h-100">
  <div
    class="p-3 rounded bg-white bg-opacity-50 h-100 d-flex flex-column align-items-start"
    [class.bg-light]="
      isRegisteredAndPending ||
      isRegisteredAndApproved ||
      isRegisteredAndRejected
    "
  >
    <div class="w-100">
      <h5 class="text-success line-2">
        {{ workshop.title }}
      </h5>
      @if (workshop?.courseLink) {
      <div>
        <a
          href="{{ workshop.courseLink }}"
          target="_blank"
          class="btn btn-outline-success"
          >جزئیات بیشتر
        </a>
      </div>
      }
    </div>

    <div class="flex-grow-1">
      <div class="mt-3 mb-auto">
        <span class="fa fa-user me-2 text-secondary"></span>
        <span class="align-self-center"
          >{{ teacherLabel }}: {{ workshop.teacherFullName }}</span
        >
      </div>
      <div class="mt-2 d-flex">
        <span class="fa fa-calendar-alt me-2 text-secondary"></span>
        <span class="align-self-center"
          >{{ holdingDateLabel }}: {{ workshop.holdingDateJalali }}</span
        >
        <span
          class="bg-warning p-1 rounded ms-2 align-self-center"
          style="text-wrap: nowrap"
          *ngIf="workshop.daysLeft > 0"
          >{{ workshop.daysLeft }} {{ daysLeftLabel }}</span
        >
      </div>
      <div class="mt-2">
        <span class="fa fa-layer-group me-2 text-secondary"></span>
        <span class="align-self-center"
          >{{ holdingTypeLabel }}: {{ workshop.holdingTypeTitle }}</span
        >
      </div>
      <div class="mt-2">
        <span class="fa fa-location-pin me-2 text-secondary"></span>
        <span class="align-self-center"
          >{{ locationLabel }}: {{ workshop.locationTitle }}</span
        >
      </div>
      <div class="mt-2" *ngIf="showDescription && workshop.description">
        <p>{{ workshop.description }}</p>
      </div>
    </div>
    <div>
      <button
        class="btn btn-success btn-block mt-3"
        (click)="onRegisterButtonClick(workshop.id)"
        *ngIf="canRegister"
      >
        <span class="fa fa-user-plus me-2"></span>
        {{ registerLabel }}
      </button>
      <button
        class="btn btn-secondary btn-block mt-3 disabled"
        *ngIf="isRegisteredAndPending"
      >
        <span class="fa fa-hourglass me-2"></span>
        {{ registeredAndPendingLabel }}
      </button>
      <button
        class="btn btn-danger btn-block mt-3 disabled"
        *ngIf="isRegisteredAndRejected"
      >
        <span class="fa fa-ban me-2"></span>
        {{ registeredAndRejectedLabel }}
      </button>
      <button
        class="btn btn-success btn-block mt-3 disabled"
        *ngIf="isRegisteredAndApproved"
      >
        <span class="fa fa-user-check me-2"></span>
        {{ registeredAndApprovedLabel }}
      </button>
      <a
        class="btn btn-outline-success btn-block mt-3 ms-2"
        target="_blank"
        href="{{ workshop.googleCalendarNewEventUrl }}"
        *ngIf="workshop?.googleCalendarNewEventUrl"
      >
        <span class="fa fa-add me-2"></span>
        {{ addToGoogleCalendarLabel }}
      </a>
    </div>
  </div>
</div>
<dx-popup
  deferRendering="true"
  contentTemplate="content"
  height="auto"
  width="auto"
  hideOnOutsideClick="true"
  rtlEnabled="true"
  [(visible)]="showApprovalPromptPopup"
>
  <div *dxTemplate="let data of 'content'">
    <app-registration-approval-prompt></app-registration-approval-prompt>
  </div>
</dx-popup>
